import React from 'react';
import {
  Box,
  Button,
  Heading,
  Icon,
  Image,
  SimpleGrid,
  Stack,
  Text,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { MdCheck } from 'react-icons/md';
import Container from '../ui/Container';
import site from '../../config/site';
import scanImage from '../../img/print.jpg';

const BENEFITS = [
  'Almacenamiento centralizado de planos.',
  'Acceso rápido mediante códigos QR.',
  'Control de versiones de cada documento.',
  'Consulta desde cualquier dispositivo móvil.',
  'Gestión segura de usuarios y permisos.',
  'Historial de cambios del proyecto.',
];

export default function SiesaAppSection() {
  return (
    <Box
      as="section"
      bg="brand.900"
      color="text.inverse"
      py={{ base: 14, md: 20 }}
    >
      <Container>
        <SimpleGrid
          columns={{ base: 1, lg: 2 }}
          spacing={{ base: 10, lg: 16 }}
          alignItems="center"
        >
          <Stack spacing={5}>
            <Text
              fontSize="xs"
              fontWeight={700}
              letterSpacing="0.08em"
              textTransform="uppercase"
              color="brand.100"
            >
              Siesa QR App
            </Text>
            <Heading as="h2" size="h2" color="text.inverse">
              Todos los planos de su proyecto disponibles desde cualquier lugar
            </Heading>
            <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={3} pt={2}>
              {BENEFITS.map(benefit => (
                <Stack
                  key={benefit}
                  direction="row"
                  spacing={2}
                  align="flex-start"
                >
                  <Icon
                    as={MdCheck}
                    color="brand.100"
                    boxSize={5}
                    mt={0.5}
                    flexShrink={0}
                    aria-hidden="true"
                  />
                  <Text fontSize="sm" color="whiteAlpha.900">
                    {benefit}
                  </Text>
                </Stack>
              ))}
            </SimpleGrid>
            <Stack direction={{ base: 'column', sm: 'row' }} spacing={3} pt={4}>
              <Button
                as={RouterLink}
                to="/siesa-qr-app"
                bg="white"
                color="brand.900"
                _hover={{ bg: 'brand.100' }}
              >
                Conocer Siesa QR App
              </Button>
              <Button
                as={RouterLink}
                to="/contact?subject=siesa-qr-app"
                variant="inverse"
              >
                Solicitar demostración
              </Button>
              <Button
                as="a"
                href={site.siesaAppUrl}
                target="_blank"
                rel="noopener noreferrer"
                variant="inverse"
              >
                Iniciar sesión
              </Button>
            </Stack>
          </Stack>

          <Image
            src={scanImage}
            alt="Consulta de planos mediante código QR en campo"
            borderRadius="lg"
            w="100%"
            h={{ base: '260px', lg: '420px' }}
            objectFit="cover"
            loading="lazy"
            decoding="async"
          />
        </SimpleGrid>
      </Container>
    </Box>
  );
}
